import 'buefy/dist/buefy.css'
import SmoothScrollbar from 'vue-smooth-scrollbar'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'

import Vue from 'vue'
import App from './app.vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import HelperMixin from "./error.mixin";
import VueCookies from 'vue-cookies'
import Truncate from "./truncate.filter";
import vClickOutside from "v-click-outside";

Vue.mixin(HelperMixin);
Vue.use(VueCookies)
Vue.use(SmoothScrollbar)
Vue.use(Buefy)
Vue.use(vClickOutside)
Vue.config.productionTip = false
Vue.component('treeselect', Treeselect)
Vue.filter("truncate", Truncate);

Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)

import linkify from 'vue-linkify'

Vue.directive('linkified', linkify)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
